import React, { useEffect, useState } from "react";

const KEY = "dwc_age_verified";

export const AgeGate = () => {
  const [open, setOpen] = useState(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    try {
      const ok = localStorage.getItem(KEY);
      if (!ok) setOpen(true);
    } catch (e) {
      setOpen(true);
    }
  }, []);

  const confirm = () => {
    try { localStorage.setItem(KEY, "1"); } catch (e) {}
    setOpen(false);
  };

  const deny = () => setDenied(true);

  if (!open) return null;

  return (
    <div
      data-testid="age-gate"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/95 text-white p-6"
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute inset-0 grain pointer-events-none opacity-60" aria-hidden="true" />
      <div className="relative max-w-xl w-full text-center animate-fade-up">
        <div className="mb-8 flex items-center justify-center">
          <div className="inline-flex items-center gap-3 border border-white/20 px-4 py-2 text-[10px] uppercase tracking-[0.3em] text-white/70">
            <span className="w-1.5 h-1.5 bg-brand rounded-full" /> District Wellness Center
          </div>
        </div>
        <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] mb-6">
          Are you <span className="text-brand">21</span> or older?
        </h2>
        <p className="text-white/70 text-sm sm:text-base max-w-md mx-auto mb-10">
          You must be at least 21 years of age to enter this website. By entering you agree to our terms
          and confirm you meet DC Office of Cannabis Administration requirements.
        </p>

        {!denied ? (
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              data-testid="age-gate-yes"
              onClick={confirm}
              className="px-8 py-4 bg-brand hover:bg-brand-600 text-white text-sm uppercase tracking-[0.2em] transition-colors"
            >
              Yes, I am 21+
            </button>
            <button
              data-testid="age-gate-no"
              onClick={deny}
              className="px-8 py-4 border border-white/25 hover:border-white/60 text-white text-sm uppercase tracking-[0.2em] transition-colors"
            >
              No, take me back
            </button>
          </div>
        ) : (
          <div data-testid="age-gate-denied" className="border border-white/20 p-8">
            <p className="font-serif text-2xl mb-3">We're sorry.</p>
            <p className="text-white/70 text-sm">
              You must be 21 or older to access District Wellness Center.
            </p>
          </div>
        )}

        <p className="mt-10 text-[10px] uppercase tracking-[0.25em] text-white/35">
          4915 Georgia Ave NW · Washington, DC
        </p>
      </div>
    </div>
  );
};

export default AgeGate;
